import type { RootState } from "~/redux/store";
import instance from "~/utils/i18n";
import { XML_TRANSLATION_SHEETS } from "~/Configurators/common/useXmlConfiguratorTranslations";
import { SummaryDataProvider } from "~/Configurators/Shaft/SummaryDataProvider";
import type { ConfiguratorPageDefinition } from "~/Configurators/ConfiguratorPageDefinition";
import { sendEvent } from "~/feature/Analytics/ga/ga";
import { getConfiguratorFamilyFromProductCode } from "../ConfiguratorType";
import type { WithT } from "i18next";

export const makeSummaryDataProvider = (state: RootState) => {
  const configuratorType = state.linearConfigurator.type!;
  const productCode = state.linearConfigurator.productCode!;

  const configuratorFamily = getConfiguratorFamilyFromProductCode(productCode);
  const originalT = instance.getFixedT("en", XML_TRANSLATION_SHEETS[configuratorType].sheetName);
  const t = ((key: string, options?: object) =>
    originalT(key, { context: configuratorFamily, ...options })) as WithT["t"];
  return new SummaryDataProvider(state.linearConfigurator, t);
};

export function convertToSnakeCase(name: string) {
  return name.trim().replace(/\s+/g, "_").toLowerCase();
}

export function makeSendStepCompletedEvent(configuratorDefinition: ConfiguratorPageDefinition) {
  return (stepName: string, selectionData: Record<string, string | undefined>) => {
    sendEvent({
      event: "linearConfigInteraction",
      variant: configuratorDefinition.gaConfiguratorName,
      step: stepName,
      push_context: `${configuratorDefinition.gaConfiguratorName}_step_completed`,
      selection_data: selectionData,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);
  };
}
